/* eslint-disable no-unused-vars */
import { useEffect, useState, useRef, useContext } from 'react';
import './questionnaire-page.scss';
import Api from 'utils/api';
import { groupBy } from 'lodash';
import Question from './question';
import QuestionnaireProgressBar from './questionnaire-progress-bar';
import NextButton from './Components/next-button';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import GlobalContext from 'contexts';

export default function QuestionnairePage({
  clientProductStageId,
  closeDrawer
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [questions, setQuestions] = useState(null);
  const [questionsList, setQuestionsList] = useState([]);
  const [categories, setCategories] = useState(null);
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [questionnaireName, setQuestionnaireName] = useState('');
  const [nextBtnDisabled, setNextBtnDisabled] = useState(false);

  const { currentCustomer } = useContext(GlobalContext);
  const qTitleRef = useRef();

  useEffect(() => {
    getQuestions();
  }, []);

  function setAnswersInSessionStorage(answers) {
    answers.forEach((answer) => {
      sessionStorage.setItem('q' + answer.question.id, answer.answer);
    });
  }

  function getQuestions() {
    Api.get(
      `client-questionnaire-answers/questionnaire_name/${clientProductStageId}`
    ).then((res) => {
      setQuestionnaireName(res.data);
    });

    // Get the questionnaire questions
    Api.get(`client-questionnaire-answers/${clientProductStageId}`).then(
      (res) => {
        // setSmokingQuestionsInSessionStorage(res.data);
        setAnswersInSessionStorage(res.data);
        setQuestionsList(res.data);
        const questions = groupBy(res.data, 'question.categoryName');
        const categories = Object.keys(questions);

        setQuestions(questions);
        setCategories(categories);
        setIsLoading(false);
      }
    );
  }

  function submitQuestionnaire() {
    Api.post(
      `client-questionnaire-answers/submit_questionnaire/${clientProductStageId}`
    ).then((res) => {
      if (res.data.success === true) {
        alert('השאלון נשלח בהצלחה!');
        closeDrawer();
      } else {
        if (res?.data?.emptyAnswer?.question) {
          const question = res?.data?.emptyAnswer?.question;
          const categoryIndex = categories.findIndex(
            (c) => c === question.categoryName
          );
          setCurrentCategoryIndex(categoryIndex);
          let questionsCopy = { ...questions };
          const questionIndex = questionsCopy[question.categoryName].findIndex(
            (c) => c.question.id === question.id
          );
          questionsCopy[question.categoryName][questionIndex].focus = true;
          setQuestions(questionsCopy);
        }
      }
    });
  }

  function getQuestionsInvalidValues(questions) {
    questions = questions.filter(
      (q) =>
        (q.question.questionType === 'Numeric' &&
          q.question.availableAnswers) ||
        q.question.questionType === 'TimeInput'
    );
    console.log(questions);

    const questionsWithEmptyAnswers = [];
    questions.forEach((q) => {
      if (q.question.questionType === 'Numeric') {
        const answer = sessionStorage.getItem(`q${q.question.id}`);
        const minMax = JSON.parse(q.question.availableAnswers);
        if (
          minMax &&
          minMax[0] &&
          minMax[0].min &&
          minMax[1] &&
          minMax[1].max
        ) {
          if (
            answer &&
            (parseInt(answer) < minMax[0].min ||
              parseInt(answer) > minMax[1].max)
          )
            questionsWithEmptyAnswers.push(`q${q.question.id}`);
        }
      } else if (q.question.questionType === 'TimeInput') {
        const answer = sessionStorage.getItem(`q${q.question.id}`);
        if (answer) {
          const timeArr = answer.split(':');
          const days = Number(timeArr[0]);
          const hours = Number(timeArr[1]);
          const minutes = Number(timeArr[2]);
          console.log('days: ', days);
          console.log('hours: ', hours);
          console.log('minutes: ', minutes);
          if (
            (days === 0 && (hours !== 0 || minutes !== 0)) ||
            (days !== 0 && hours === 0 && minutes === 0)
          ) {
            questionsWithEmptyAnswers.push(`q${q.question.id}`);
          }
        }
      }
    });

    return questionsWithEmptyAnswers;
  }

  function getQuestionsWithEmptyAnswers(questions) {
    questions = questions.filter(
      (q) =>
        q.question.text !== 'אחר' &&
        q.question.questionType !== 'Bool' &&
        q.question.questionType !== 'Info' &&
        q.question.isRequired !== false
    );
    console.log(questions);
    const questionIds = questions.map((q) => `q${q.question.id}`);

    const questionsWithEmptyAnswers = [];
    questionIds.forEach((qId) => {
      const answer = sessionStorage.getItem(qId);
      if (answer.trim() === '') {
        questionsWithEmptyAnswers.push(qId);
      }
    });

    return questionsWithEmptyAnswers;
  }

  function unhighlightQuestions(questions) {
    questions.forEach((q) => {
      const element = document.querySelector(`#q${q.question.id}`);
      const currentClassName = element?.className;
      if (currentClassName)
        element.setAttribute(
          'class',
          currentClassName.replace('focus-err', '')
        );
    });
  }

  function highlightQuestionsWithEmptyAnswers(questions) {
    questions.forEach((qId) => {
      const element = document.querySelector(`#${qId}`);
      const currentClassName = element.className;
      element.setAttribute('class', `${currentClassName} focus-err`);
    });
  }

  function shouldDisplayChildQuestion(parentQuestionId, questionId) {
    if (!parentQuestionId) return true;

    if (
      (parentQuestionId >= 88 && parentQuestionId <= 94) ||
      parentQuestionId === 171
    ) {
      if (currentCustomer.gender === 'אשה') {
        return true;
      }
      return false;
    }

    const parentQuestionAnswer = sessionStorage.getItem(`q${parentQuestionId}`);
    if (parentQuestionAnswer)
      return (
        parentQuestionAnswer.trim() !== '' &&
        parentQuestionAnswer.indexOf('לא') === -1
      );
    else return false;
  }

  function nextCategory() {
    let currentCategoryQuestions = questions[categories[currentCategoryIndex]];
    currentCategoryQuestions = currentCategoryQuestions.filter((q) =>
      // shouldDisplayQuestion(q.question.id)
      shouldDisplayChildQuestion(q.question.parentQuestionId, q.question.id)
    );

    let questionsWithEmptyAnswers = getQuestionsWithEmptyAnswers(
      currentCategoryQuestions
    );
    const invalidNumericAnswers = getQuestionsInvalidValues(
      currentCategoryQuestions
    );
    unhighlightQuestions(currentCategoryQuestions);
    if (
      questionsWithEmptyAnswers.length > 0 ||
      invalidNumericAnswers.length > 0
    ) {
      questionsWithEmptyAnswers = questionsWithEmptyAnswers.concat(
        invalidNumericAnswers
      );
      const elementId = questionsWithEmptyAnswers[0];
      const element = document.querySelector(`#${elementId}`);
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      highlightQuestionsWithEmptyAnswers(questionsWithEmptyAnswers);
      return;
    }

    if (currentCategoryIndex < categories.length - 1) {
      setCurrentCategoryIndex(currentCategoryIndex + 1);
      const elementId = `q${currentCategoryQuestions[0].question.id}`;
      const element = document.querySelector(`#${elementId}`);
      element?.scrollIntoView({ block: 'end' });
    } else {
      submitQuestionnaire();
    }
  }

  function prevCategory() {
    if (currentCategoryIndex > 0) {
      setCurrentCategoryIndex(currentCategoryIndex - 1);
    }
  }

  // TODO: also update on start
  function updateConditions(questionId, answer) {
    sessionStorage.setItem('q' + questionId, answer);
  }

  const searchChildren = (myArr, sourceQuestionId) => {
    const childQuestion = questionsList.filter(
      (q) =>
        q.question.parentQuestionId === sourceQuestionId &&
        q.question.questionType === 'Bool'
    );
    if (childQuestion.length) {
      myArr.push(childQuestion);
      for (let index = 0; index < childQuestion.length; index++) {
        searchChildren(myArr, childQuestion[index].question.id);
      }
    }
    return myArr;
  };

  //TODO: post all child questions in one call to server
  //check on genetic if to send C2???

  const updateAnswer = async (
    questionId,
    answer,
    questionariesValue,
    sourceQuestionId
  ) => {
    updateConditions(questionId, answer);
    setNextBtnDisabled(true);
    const myArr = [];
    const childQuestionsResult = await searchChildren(myArr, sourceQuestionId);
    if (childQuestionsResult.length) {
      for (let i = 0; i < childQuestionsResult.length; i++) {
        for (let j = 0; j < childQuestionsResult[i].length; j++) {
          Api.patch(
            `/client-questionnaire-answers/${childQuestionsResult[i][j].id}`,
            {
              answer: 'לא',
              questionariesValue: 'C2',
              sourceQuestionId: childQuestionsResult[i][j].question.id
            }
          ).then(() => {});
        }
      }
    }
    Api.patch(`/client-questionnaire-answers/${questionId}`, {
      answer: answer,
      questionariesValue: questionariesValue,
      sourceQuestionId: sourceQuestionId
    }).then(() => {
      getQuestions();
      setNextBtnDisabled(false);
    });
  };

  const updateAnswerDebounce = debounce(
    (questionId, answer, questionariesValue, sourceQuestionId) => {
      updateConditions(questionId, answer);

      Api.patch(`/client-questionnaire-answers/${questionId}`, {
        answer: answer,
        questionariesValue: questionariesValue,
        sourceQuestionId: sourceQuestionId
      }).then(() => {
        getQuestions();
      });
    },
    20
  );

  // function shouldDisplayQuestion(questionId) {
  //     const id = questionId;

  //     if ((id >= 88 && id <= 94) || id === 171) {
  //         if (sessionStorage.getItem('q268') === 'נקבה') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     if (id === 186 || id === 187) {
  //         if (sessionStorage.getItem('q185') === 'כן') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     if (id === 315 || id === 316) {
  //         if (sessionStorage.getItem('q314') === 'כן') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     if (id === 323) {
  //         if (sessionStorage.getItem('q322') === 'כן') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     if (id === 194) {
  //         if (sessionStorage.getItem('q193') === 'כן') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     if (id >= 197 && id <= 200) {
  //         if (sessionStorage.getItem('q196') === 'כן') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     if (id === 262) {
  //         if (sessionStorage.getItem('q205') === 'כן') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     if (id === 388) {
  //         if (sessionStorage.getItem('q334') === 'כן') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     if (id === 263 || id === 389 || id === 264 || id === 390) {
  //         if (sessionStorage.getItem('q230') === 'כן') {
  //             return true;
  //         }
  //         if (sessionStorage.getItem('q356') === 'כן') {
  //             return true;
  //         }
  //         return false;
  //     }

  //     return true;
  // }

  function getCategoryTitle() {
    const category = categories[currentCategoryIndex];

    switch (category) {
      // case 'רקע רפואי':
      //     return 'אם אובחנת / סובל.ת מהמחלות ו / או הבעיות הרפואיות הרשומות מטה ? נא לסמן';

      // case 'שאלות לנשים':
      //     return 'האם היית/הנך בתהליכים/מצבים הבאים?';

      case 'רקע רפואי משפחתי':
        return 'האם קרוב משפחה מדרגה ראשונה (הורים, אחים, ילדים) אובחנו במחלות ו / או בבעיות הרפואיות הרשומות מטה ? נא סמנ/י';

      case 'מצב רפואי כללי':
        return 'מצב רפואי כללי';

      case 'אירועים רפואיים':
        return 'האם עברת ניתוח/טיפול מהבאים?';

      // case 'הרגלי אכילה':
      //     return 'מה מהמשפטים הבאים מאפיין את הרגלי האכילה שלך?';

      case 'נטיה לנשנושים':
        return 'באיזו תדירות הנך צורך את הבאים?';

      case 'פעילות גופנית':
        return 'באזו תדירות הינך מבצע/ת פעילות גופנית?';

      default:
        return null;
    }
  }

  return isLoading ? (
    'Loading...'
  ) : (
    <div className="wrapper-questionnaire-page">
      <div className="questionnaire-page">
        <div className="questionnaire-title" ref={qTitleRef}>
          <span className="back-button" onClick={prevCategory}>
            {'<'}
          </span>
          <span>{questionnaireName}</span>
        </div>
        <QuestionnaireProgressBar
          categories={categories}
          currentCategoryIndex={currentCategoryIndex}
        />

        {getCategoryTitle() !== null && (
          <h4 className="category-subtitle">{getCategoryTitle()}</h4>
        )}

        {/* Current category questions */}
        <div className="wrapper-questions">
          {questions[categories[currentCategoryIndex]]
            .sort((a, b) => a.question.orderNumber - b.question.orderNumber)
            ?.map((q) => {
              return (
                // shouldDisplayQuestion(q.question.id) && (
                <Question
                  key={q.question.id}
                  {...q}
                  updateAnswer={(answer, questionariesValue) => {
                    updateAnswer(
                      q.id,
                      answer,
                      questionariesValue,
                      q.question.id
                    );
                  }}
                  updateAnswerDebounce={(answer, questionariesValue) =>
                    updateAnswerDebounce(
                      q.id,
                      answer,
                      questionariesValue,
                      q.question.id
                    )
                  }
                  isFocus={q.focus}
                />
                // )
              );
            })}
        </div>
        <NextButton disabled={nextBtnDisabled} onClick={nextCategory}>
          {currentCategoryIndex < categories.length - 1 ? 'הבא' : 'סיום'}
        </NextButton>
      </div>
    </div>
  );
}

QuestionnairePage.propTypes = {
  clientProductStageId: PropTypes.string,
  closeDrawer: PropTypes.function
};
